import { ApiComm } from '../comm';
import { ResponseDTO } from '../dto/ResponseDTO';
import { genNoobookHeader } from './Common';
import { ReportedBookcommunityDTO, BookcommunityInfoDTO} from '../dto/BookcommunityDTOs';


export function getPopularBookcommunities(authToken:string, page:number, size:number):Promise<ResponseDTO<BookcommunityInfoDTO[]>>
{
    return ApiComm.getData<ResponseDTO<BookcommunityInfoDTO[]>>(`/close/v1/bookcommunity/hashtag/bookcommunities`
        , {page:page, size:size, sort:["total_count,desc","bc.created_at,desc"]}
        , genNoobookHeader(authToken, null, 'application/json', "app")
    ).then(resp=>resp.data);
}



export function getReportedBookcommunities(
  authToken: string,
  page: number = 1,
  size: number = 10
): Promise<ResponseDTO<ReportedBookcommunityDTO[]>> {
  return ApiComm.getData<ResponseDTO<ReportedBookcommunityDTO[]>> (
    '/close/v1/admin/v1/bookcommunity/reported/bookcommunities' //, {page: page, size: size}, genNoobookHeader(authToken, null, 'application/json', 'app')).then(resp => resp.data);
    , {page:page, size:size}
    , genNoobookHeader(authToken, null, 'application/json', "admin_web")).then(resp => resp.data);
}
  
export function sendWarningMessageToReportedBookcommunity(
  authToken: string,
  bookcommunityId: number,
  warningMessage: string
): Promise<ResponseDTO<boolean>> {
  return ApiComm.postData<ResponseDTO<boolean>> (
    `/close/v1/admin/bookcommunity/${bookcommunityId}/warning`,
    warningMessage, genNoobookHeader(authToken, null, 'plain/text', "admin_web")).then(resp => resp.data);
}




